import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)(({ theme }) => ({
  padding: `${theme.spacing(1.5)} ${theme.spacing(4)}`,
  background: theme.palette.secondary.main,
  display: 'grid',
  alignItems: 'center',
  columnGap: theme.spacing(1.5),
  gridTemplateColumns: 'max-content 1fr max-content',
}));
